/*
- Append YMM Javascript file into Head element of Web page.
- For "Modern Browsers" it will support ES6 versions, so include plain JS with script type "module".
- For "Older Browsers" include babel / vite generated transpiled JS with tag "nomodule".
*/
if (typeof window.cwsApp.ymmLoadScript === 'undefined') {
window.cwsApp.ymmLoadScript = function (baseUrl, baseId, callback) {
  // Track loaded scripts to ensure callback fires ONLY ONCE
  window.cwsApp.ymmScriptLoaded = window.cwsApp.ymmScriptLoaded || {};

  // Fire callback once per script (prevents ES6 + ES5 double execution)
  function ymmFireCallbackOnce(scriptKey) {
    if (window.cwsApp.ymmScriptLoaded[scriptKey]) return;
    window.cwsApp.ymmScriptLoaded[scriptKey] = true;
    if (callback) callback();
  }
  
  // For YMM App external JS plugins, use standard JavaScript (no `type="module"`)
  var ymmExternalPlugins = ['slim', 'lozad'];
  var ymmIsExternalPlugin = false;
  var ymmExternalJSLen = ymmExternalPlugins.length;

  for (var i = 0; i < ymmExternalJSLen; i++) {
    if (baseUrl.indexOf(ymmExternalPlugins[i]) !== -1) {
      ymmIsExternalPlugin = true;
      break;
    }
  }

  var ymmHead = document.getElementsByTagName("head")[0];

  // Modern ES6+ version
  var modernScript = document.createElement("script");

  if (ymmIsExternalPlugin) {
    modernScript.type = "text/javascript";
    modernScript.id = baseId;
  } else {
    modernScript.type = "module";
    modernScript.id = baseId + "_modern";
  }

  modernScript.src = baseUrl;
  modernScript.defer = true;

  // MODERN SCRIPT CALLBACK
  modernScript.onload = modernScript.onreadystatechange = function () {
    if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
      this.onload = this.onreadystatechange = null;
      ymmFireCallbackOnce(baseId);
    }
  };

  // Legacy ES5 fallback
  if (!ymmIsExternalPlugin) {
    var legacyScript = document.createElement("script");
    legacyScript.setAttribute("nomodule", "");

    if (baseUrl != "") {
      var ymmUrlParts = baseUrl.split("?");
      baseUrl = ymmUrlParts[0].replace(/\.js$/, ".min.js") + (ymmUrlParts[1] ? "?" + ymmUrlParts[1] : "");
    }

    legacyScript.src = baseUrl;
    legacyScript.id = baseId + "_legacy";
    legacyScript.defer = true;

    // LEGACY SCRIPT CALLBACK
    legacyScript.onload = legacyScript.onreadystatechange = function () {
      if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
        this.onload = this.onreadystatechange = null;
        ymmFireCallbackOnce(baseId);
      }
    };

    ymmHead.appendChild(legacyScript);
  }

  // Append modern script at last.
  ymmHead.appendChild(modernScript);
};
}

// Efficiently append/update external CSS & dynamic inline CSS
if (typeof window.cwsApp.ymmLoadCss === "undefined") {
  // Load this common CSS for very older OS theme client (before 0 file put API)
  if(document.querySelector('[data-ymm-theme-type="os"]') !== null) {
    window.cwsApp.ymmUtilityCssAdded = false;
  }
 
  // Load utility CSS FIRST (only once)
  if (!window.cwsApp.ymmUtilityCssAdded) {
    const ymmUtil = document.createElement("link");
    ymmUtil.rel = "stylesheet";
    ymmUtil.type = "text/css";
    ymmUtil.id = "ymm-utility-css";
    ymmUtil.href = window.cwsApp.ymmUtilityCssPath;
    document.head.appendChild(ymmUtil);
    window.cwsApp.ymmUtilityCssAdded = true;
  }

  window.cwsApp.ymmLoadCss = function (options) {
    if (!options || typeof options !== "object") return;

    const head = document.head || document.getElementsByTagName("head")[0];
    if (!head) return;

    // --- 1. External CSS file ---
    if (options.href) {
      const linkId = options.id ? options.id + "_link" : null;
      let linkEl = linkId ? document.getElementById(linkId) : null;

      if (!linkEl) {
        linkEl = document.createElement("link");
        linkEl.rel = "stylesheet";
        linkEl.type = "text/css";
        if (linkId) linkEl.id = linkId;
        if (options.media) linkEl.media = options.media;

        head.appendChild(linkEl);   // simple append
      }

      linkEl.href = options.href;   // update
    }

    // --- 2. Inline dynamic CSS ---
    if (options.cssText) {
      const styleId = options.id ? options.id + "_style" : null;
      let styleEl = styleId ? document.getElementById(styleId) : null;

      if (!styleEl) {
        styleEl = document.createElement("style");
        styleEl.type = "text/css";
        if (styleId) styleEl.id = styleId;
        head.appendChild(styleEl);
      }

      if (styleEl.styleSheet) styleEl.styleSheet.cssText = options.cssText;
      else styleEl.innerHTML = options.cssText;
    }
  };
}

// Get YMM Query Parameter value like: ?rq=[ymm] then to get "?rq" value.
window.cwsApp.getYMMParameter = function(name,url) {
  if (!url) url = window.location.href;
  
  name = name.replace(/[\[\]]/g, "\\$&");
  
  var ymmRegex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
  ymmResults = ymmRegex.exec(url);
  
  if (!ymmResults) return null;
  
  if (!ymmResults[2]) return '';
  
  return decodeURIComponent(ymmResults[2].replace(/\+/g, " "));
};

// Below func. will give YMM tags ARRAY that will need to pass on server end!
window.cwsApp.getYMMTags = function() {
  let ymmTags = window.cwsApp.getYMMParameter('rq');
  if (!ymmTags) return []; // null/undefined - empty array

  let ymmQuerySign = "";

  if (ymmTags.indexOf("~") >= 0) ymmQuerySign = "~";
  if (ymmTags.indexOf("__") >= 0) ymmQuerySign = "__";

  if (ymmQuerySign !== "")  return ymmTags.toString().split(ymmQuerySign);
  
  // If no separator found, return as single-item array
  return [ymmTags.toString()];
}

// Below func. is utility provided for ymm result page price formatting same like shopify api.jquery.js file.
window.cwsApp.ymmFormatMoney = function (cents, format) {
  if (typeof cents === 'string') { cents = cents.replace('.', ''); }

  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format;

  function defaultOption(opt, def) {
    return (typeof opt === 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    const parts   = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_space_separator": 
      value = formatWithDelimiters(cents, 2, " ", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// jQuery nextAll() in pure JS.
window.cwsApp.ymmNextAll = function(startElement) {
  const allSiblings = Array.from(startElement.parentNode.children);
  const startIndex = allSiblings.indexOf(startElement);
  const nextAllElements = allSiblings.slice(startIndex + 1);

  return nextAllElements;
}

// jQuery hasClass() in pure JS.
window.cwsApp.ymmHasClass = function(element, className) {
  return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
}

// jQuery index() in pure JS.
window.cwsApp.ymmIndex = function(elem) {
  if (!elem) return -1;
  let i = 0;
  while ((elem = elem.previousElementSibling) != null) {
    i++;
  }
  return i;
}

// jQuery in_array() in pure JS.
window.cwsApp.ymmInArray = function(value, array) {
  return array.indexOf(value) !== -1;
}

// Remove all of next 'li' siblings (ymm fields) but not YMM buttons.
window.cwsApp.ymmRemoveNextUntilButtons = function(elem) {
  while (elem && elem.nextElementSibling && !window.cwsApp.ymmHasClass(elem.nextElementSibling, 'ymm_bttns')) {
    elem.nextElementSibling.remove();
  }
}

// This will enable/disable element if element found.
window.cwsApp.ymmSetDisableProperty = function(elem, mode) {
  let ymmEle = null;

  if (typeof elem === "string") {
    ymmEle = document.querySelector(elem);
  } else if (elem instanceof Element) {
    ymmEle = elem;
  }

  if (ymmEle) ymmEle.disabled = mode;
}

// This will set element visibility if element found.
window.cwsApp.ymmSetElementVisibility = function(elem,prop) {
  let ymmEle = null;

  if (typeof elem === "string") {
    ymmEle = document.querySelector(elem);
  } else if (elem instanceof Element) {
    ymmEle = elem;
  }
  
  if (ymmEle) ymmEle.style.display = prop;
}

// This will remove element if element found.
window.cwsApp.ymmRemoveElement = function(elem) {
  let ymmEle = null;

  if (typeof elem === "string") {
    ymmEle = document.querySelector(elem);
  } else if (elem instanceof Element) {
    ymmEle = elem;
  }

  if (ymmEle) ymmEle.remove();
}

// jQuery fadeOut in pure JS.
window.cwsApp.ymmFadeout = function(elem, duration) {
  const el = document.querySelector(elem);
  if (!el) return;

  el.style.display = "block";
  el.style.opacity = "1";

  setTimeout(function () {
    el.style.transition = "opacity " + (duration || 500) + "ms";
    el.style.opacity = "0";

    setTimeout(function () {
      el.style.display = "none";
      el.style.opacity = "1";
      el.style.transition = "";
    }, duration || 500);
  }, 50); // THIS makes it visible first time
};

// jQuery fadeIn in pure JS.
window.cwsApp.ymmFadeIn = function(elem, duration = 500, callback) {
  const el = typeof elem === "string" ? document.querySelector(elem) : elem;
  if (!el) return;

  el.style.opacity = 0;
  el.style.display = "block";
  el.style.transition = `opacity ${duration}ms`;

  requestAnimationFrame(() => {
    el.style.opacity = 1;
  });

  setTimeout(() => {
    if (typeof callback === "function") callback();
  }, duration);
};

// Check element exists while scrolling.
window.cwsApp.ymmElementIsInViewport = function(element) {
  const el = document.querySelector(element);
  
  if (el) {
    const hT = el.getBoundingClientRect().top + window.scrollY;
    const hH = el.offsetHeight;
    const wH = window.innerHeight;
    const wS = window.scrollY;

    return wS > (hT + hH - wH);
  } else {
    return false;
  }
}

/* --- Slide up / down functions in vanilla JS --- */
window.cwsApp.ymmSlideUp = function(el, duration) {
  if (!el || el._sliding) return;
  el._sliding = true;

  const style = el.style;
  const height = el.offsetHeight + "px";

  style.height = height;
  style.overflow = "hidden";
  style.transition = `height ${duration}ms ease, padding ${duration}ms ease, margin ${duration}ms ease`;

  // Force reflow
  el.offsetHeight;

  // Animate to 0
  style.height = "0";
  style.paddingTop = "0";
  style.paddingBottom = "0";
  style.marginTop = "0";
  style.marginBottom = "0";

  window.setTimeout(() => {
    style.display = "none";
    style.removeProperty("height");
    style.removeProperty("padding-top");
    style.removeProperty("padding-bottom");
    style.removeProperty("margin-top");
    style.removeProperty("margin-bottom");
    style.removeProperty("overflow");
    style.removeProperty("transition");
    el._sliding = false;
  }, duration);
}

window.cwsApp.ymmSlideDown = function(el, duration = 300) {
  if (!el || el._sliding) return;
  el._sliding = true;

  const style = el.style;

  // Prepare element
  style.removeProperty("display");
  let display = window.getComputedStyle(el).display;
  if (display === "none") display = "block";
  style.display = display;

  const height = el.scrollHeight + "px";

  style.overflow = "hidden";
  style.height = "0";
  style.paddingTop = "0";
  style.paddingBottom = "0";
  style.marginTop = "0";
  style.marginBottom = "0";

  // Force reflow
  el.offsetHeight;

  style.transition = `height ${duration}ms ease, padding ${duration}ms ease, margin ${duration}ms ease`;
  style.height = height;
  style.removeProperty("padding-top");
  style.removeProperty("padding-bottom");
  style.removeProperty("margin-top");
  style.removeProperty("margin-bottom");

  window.setTimeout(() => {
    style.removeProperty("height");
    style.removeProperty("overflow");
    style.removeProperty("transition");
    el._sliding = false;
  }, duration);
}

// Escape text for HTML attributes (title, data-*, etc.)
window.cwsApp.ymmEsc = function (str) {
  return String(str || '').replace(/"/g, '&quot;');
};

// Common unified functions for closing all YMM modals ("My Garage Popup" + "Additional Information" Popup)
window.cwsApp.hideYmmModalPopup = function(){
  if(window.cwsApp.ymmBody) window.cwsApp.ymmBody.classList.remove('ymm_modal_open');

  const ymmModal = document.querySelector('.ymm_modal.active');
  if (ymmModal) ymmModal.classList.remove('active');  
};

/* Below are event handlers uniformly defined for 'Close Modal' action that is done either
via press escape key or by click on overlay. */
window.cwsApp.ymmEscKeyHandler = function (e) {
  if (!e) return;

  if (e.keyCode === 27 || e.key === 'Escape') {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    // Close active modal popup.
    window.cwsApp.hideYmmModalPopup();

    // Close active facet filters
    if (typeof window.cwsApp.ymmCloseActiveFilters === "function") window.cwsApp.ymmCloseActiveFilters();
    
    // Close YMM filter drawer
    if (typeof window.cwsApp.closeYmmDrawer === "function") window.cwsApp.closeYmmDrawer();
  } 
};

document.removeEventListener('keyup', window.cwsApp.ymmEscKeyHandler, true);
document.addEventListener('keyup', window.cwsApp.ymmEscKeyHandler, true);

window.cwsApp.ymmOutsideClickHandler = function (e) {
  const ymmCustDataPopup = document.querySelector('div.ymm_cust_data_popup.active');
  const ymmGarageModal = document.querySelector('div.ymm_garage_modal.active');

  // if overlay exists AND clicked on exactly that overlay
  if ((ymmCustDataPopup && e.target === ymmCustDataPopup) || 
    (ymmGarageModal && e.target === ymmGarageModal)) {
    // STOP browser from opening link behind overlay
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    
    window.cwsApp.hideYmmModalPopup();
  }
};

["click", "touchend"].forEach(function (evt) {
  document.removeEventListener(evt, window.cwsApp.ymmOutsideClickHandler);
  document.addEventListener(evt, window.cwsApp.ymmOutsideClickHandler);
});

/* --- Pagination Vanilla JS Class --- */
class ymmPagination {
  constructor(target, options = {}) {
    this.target = typeof target === "string" ? document.querySelector(target) : target;

    // Default paging color (can be overridden later)
    const pagingColor = options.pagingColor || "#000000";

    this.options = Object.assign({
      total: 1,
      length: 10,
      current: 1,
      size: 2,
      prev: window.cwsApp.getYmmPagingIcon ? window.cwsApp.getYmmPagingIcon("prev", pagingColor) : "&laquo;",
      next: window.cwsApp.getYmmPagingIcon ? window.cwsApp.getYmmPagingIcon("next", pagingColor) : "&raquo;",
      ajax: null,
      click: null
    }, options);
        
    this.ymmDataFetching = false; // Important

    this.init();
  }

  init() {
    // Only fetch if AJAX is defined
    if (typeof this.options.ajax === "function") {
      this.options.ajax({
        current: this.options.current,
        length: this.options.length,
        total: this.options.total
      }, this.refresh.bind(this), this.target);
    } else {
      // No AJAX, render immediately
      this.render();
    }
  }

  render() {
    if (!this.target || this.options.total <= 0) return; // don't render if total is unknown
      this.target.innerHTML = "";

      const totalPages = Math.ceil(this.options.total / this.options.length);
      
      // If total products <= limit (only 1 page), do NOT render pagination
      if (totalPages <= 1) return;
      
      const { current, size, prev, next } = this.options;

      const ul = this.target;

      // Prev
      const prevLi = document.createElement("li");
      prevLi.innerHTML = `<a href="#">${prev}</a>`;
      if (current <= 1) prevLi.classList.add("disabled");
      else prevLi.addEventListener("click", e => {
        e.preventDefault();
        this.goTo(current - 1);
      });
      
      ul.appendChild(prevLi);

      // Page numbers
      let start = Math.max(1, current - size);
      let end = Math.min(totalPages, current + size);

      if (start > 1) {
        ul.appendChild(this.pageLink(1));
        if (start > 2) ul.appendChild(this.dots());
      }

      for (let i = start; i <= end; i++) {
        ul.appendChild(this.pageLink(i, i === current));
      }

      if (end < totalPages) {
        if (end < totalPages - 1) ul.appendChild(this.dots());
        ul.appendChild(this.pageLink(totalPages));
      }

      // Next
      const nextLi = document.createElement("li");
      nextLi.innerHTML = `<a href="#">${next}</a>`;
      if (current >= totalPages) nextLi.classList.add("disabled");
      else nextLi.addEventListener("click", e => {
        e.preventDefault();
        this.goTo(current + 1);
      });
      
      ul.appendChild(nextLi);
    }

    pageLink(page) {
      const li = document.createElement("li");
      const ymmPageAnchor = document.createElement("a");
      ymmPageAnchor.href = "#";
      ymmPageAnchor.dataset.page = page;  // same as jQuery plugin
      ymmPageAnchor.textContent = page;
      li.appendChild(ymmPageAnchor);

      // mark active by comparing current vs page
      if (Number(this.options.current) === Number(page)) {
        li.classList.add("active");
      }

      ymmPageAnchor.addEventListener("click", e => {
        e.preventDefault();
        this.goTo(page);
      });

      return li;
    }

    dots() {
      const li = document.createElement("li");
      li.className = "dots";
      li.innerHTML = "...";
      return li;
    }

    goTo(page) {
      if (this.ymmDataFetching) return; // prevent multiple fetches
        this.options.current = page;

        if (typeof this.options.ajax === "function") {
          this.ymmDataFetching = true; // lock

          // Only fetch; render happens in refresh()
          this.options.ajax({
            current: this.options.current,
            length: this.options.length,
            total: this.options.total
          }, (newOptions) => {
            this.refresh(newOptions);
            this.ymmDataFetching = false; // unlock after refresh
          }, this.target);
        } else {
          this.render(); // render immediately if no AJAX
        }

        if (typeof this.options.click === "function") {
          this.options.click({
            current: this.options.current,
            length: this.options.length,
            total: this.options.total
          }, this.target);
        }
    }

    refresh(newOptions = {}) {
      if (typeof newOptions === "object") {
        if (newOptions.total) this.options.total = newOptions.total;
        if (newOptions.length) this.options.length = newOptions.length;
        if (newOptions.current) this.options.current = newOptions.current;
      }
    
      this.render();
    }
}

window.cwsApp.ymmPagination = ymmPagination;

// DEFINE SVG HTML of YMM APP
window.cwsApp.YMM_EYE_ICON_HTML = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" 
       viewBox="0 0 24 24" fill="none" stroke="currentColor" 
       stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
       class="icon feather feather-eye ymm_dtl">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
`;

window.cwsApp.YMM_EYE_OFF_ICON_HTML = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" 
       viewBox="0 0 24 24" fill="none" stroke="currentColor" 
       stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
       class="icon feather feather-eye-off ymm_dtl">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
    <line x1="1" y1="1" x2="23" y2="23"></line>
  </svg>
`;

window.cwsApp.YMM_TRASH_ICON_HTML = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" 
       stroke="currentColor" stroke-width="2" stroke-linecap="round" 
       stroke-linejoin="round" class="icon feather feather-trash-2 ymm_dlt_svg">
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4
             a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
    <line x1="10" y1="11" x2="10" y2="17"></line>
    <line x1="14" y1="11" x2="14" y2="17"></line>
  </svg>
`;

window.cwsApp.YMM_LOCK_SVG = `
  <svg class="ymm_lock_icon" fill="#000000" height="50" width="50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 330" xml:space="preserve">
    <g id="XMLID_509_">
      <path id="XMLID_510_" d="M65,330h200c8.284,0,15-6.716,15-15V145c0-8.284-6.716-15-15-15h-15V85c0-46.869-38.131-85-85-85 S80,38.131,80,85v45H65c-8.284,0-15,6.716-15,15v170C50,323.284,56.716,330,65,330z M180,234.986V255c0,8.284-6.716,15-15,15 s-15-6.716-15-15v-20.014c-6.068-4.565-10-11.824-10-19.986c0-13.785,11.215-25,25-25s25,11.215,25,25 C190,223.162,186.068,230.421,180,234.986z M110,85c0-30.327,24.673-55,55-55s55,24.673,55,55v45H110V85z"/>
    </g>
  </svg>
`;

window.cwsApp.YMM_CLOSE_BTN_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
     stroke-linejoin="round" class="icon feather feather-x ymm_close_svg">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
`;

window.cwsApp.YMM_LOADER_SVG = `
  <svg version="1.1" class="ymm_loadr_icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24px" height="30px"
     viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
    <rect x="0" y="13" width="4" height="5" fill="#333">
      <animate attributeName="height" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate>
      <animate attributeName="y" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate>
    </rect>
    <rect x="10" y="13" width="4" height="5" fill="#333">
      <animate attributeName="height" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate>
      <animate attributeName="y" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate>
    </rect>
    <rect x="20" y="13" width="4" height="5" fill="#333">
      <animate attributeName="height" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate>
      <animate attributeName="y" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate>
    </rect>
  </svg>
`;

window.cwsApp.YMM_EMAIL_ICON_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
       viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
       stroke-linecap="round" stroke-linejoin="round" class="feather feather-mail my_mail">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
`;

window.cwsApp.YMM_SMS_ICON_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
       viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
       stroke-linecap="round" stroke-linejoin="round" class="feather feather-message-square my_sms">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
  </svg>
`;

window.cwsApp.YMM_PHONE_ICON_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
       viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
       stroke-linecap="round" stroke-linejoin="round" class="feather feather-phone-outgoing my_phone">
    <polyline points="23 7 23 1 17 1"></polyline>
    <line x1="16" y1="8" x2="23" y2="1"></line>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07
             19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1
             4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81
             2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27
             a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7
             A2 2 0 0 1 22 16.92z"></path>
  </svg>
`;

window.cwsApp.YMM_LINK_ICON_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
       viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
       stroke-linecap="round" stroke-linejoin="round" class="feather feather-link my_link">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
  </svg>
`;

window.cwsApp.YMM_FILTER_ICON_SVG = `
  <svg class="ymm_filter_icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" role="presentation">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.8 3.2H3.348C3.6792 4.1288 4.5584 4.8 5.6 4.8C6.6416 4.8 7.5208 4.1288 7.852 3.2H15.2C15.6424 3.2 16 2.8424 16 2.4C16 1.9576 15.6424 1.6 15.2 1.6H7.852C7.5208 0.6712 6.6416 0 5.6 0C4.5584 0 3.6792 0.6712 3.348 1.6H0.8C0.3576 1.6 0 1.9576 0 2.4C0 2.8424 0.3576 3.2 0.8 3.2ZM15.2 12.8H7.852C7.5208 11.8712 6.6416 11.2 5.6 11.2C4.5584 11.2 3.6792 11.8712 3.348 12.8H0.8C0.3576 12.8 0 13.1576 0 13.6C0 14.0424 0.3576 14.4 0.8 14.4H3.348C3.6792 15.3288 4.5584 16 5.6 16C6.6416 16 7.5208 15.3288 7.852 14.4H15.2C15.6424 14.4 16 14.0424 16 13.6C16 13.1576 15.6424 12.8 15.2 12.8ZM15.2 7.2H12.652C12.3208 6.2712 11.4416 5.6 10.4 5.6C9.3584 5.6 8.4792 6.2712 8.148 7.2H0.8C0.3576 7.2 0 7.5576 0 8C0 8.4424 0.3576 8.8 0.8 8.8H8.148C8.4792 9.7288 9.3584 10.4 10.4 10.4C11.4416 10.4 12.3208 9.7288 12.652 8.8H15.2C15.6424 8.8 16 8.4424 16 8C16 7.5576 15.6424 7.2 15.2 7.2ZM5.6 1.6C6.0416 1.6 6.4 1.9584 6.4 2.4C6.4 2.8416 6.0416 3.2 5.6 3.2C5.1584 3.2 4.8 2.8416 4.8 2.4C4.8 1.9584 5.1584 1.6 5.6 1.6ZM5.6 14.4C5.1584 14.4 4.8 14.0416 4.8 13.6C4.8 13.1584 5.1584 12.8 5.6 12.8C6.0416 12.8 6.4 13.1584 6.4 13.6C6.4 14.0416 6.0416 14.4 5.6 14.4ZM10.4 8.8C9.9584 8.8 9.6 8.4416 9.6 8C9.6 7.5584 9.9584 7.2 10.4 7.2C10.8416 7.2 11.2 7.5584 11.2 8C11.2 8.4416 10.8416 8.8 10.4 8.8Z" fill="currentColor"></path>
  </svg>
`;

window.cwsApp.YMM_MOBILE_FILTER_ICON_SVG = `
  <svg focusable="false" class="ymm-mobile-filter-icon icon icon--filter " viewBox="0 0 19 20" role="presentation">
    <path d="M17.0288086 4.01391602L11 9v7.0072021l-4 2.008545V9L1.01306152 4.01391602V1H17.0288086z" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="square"></path>
  </svg>
`;

// Unified func. for "Prev/Next" svg used in ymm App JS.
window.cwsApp.getYmmPagingIcon = function(type, color) {
  const ymmCommonAttr = 'aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide" viewBox="0 0 20 8" fill-rule="evenodd"';
  if (type === 'prev') {
    return `<svg ${ymmCommonAttr}><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="${color}"></path></svg>`;
  }
  if (type === 'next') {
    return `<svg ${ymmCommonAttr}><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="${color}"></path></svg>`;
  }
  return '';
};